import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
export default defineComponent({
    name: 'filter-sorting',
    computed: Object.assign({ select: {
            get: function () {
                return this.currentSorting;
            },
            set: function (value) {
                this.setPriceSorting(value);
            },
        } }, mapGetters('blue', {
        currentSorting: 'currentSorting',
    })),
    methods: Object.assign({}, mapActions('blue', {
        setPriceSorting: 'PRODUCT_LISTING_SET_PRICE_SORTING',
    })),
    data: () => ({
        items: [
            { state: 'Beste Ergebnisse', abbr: 'scoring' },
            { state: 'Neu eingetroffen', abbr: 'newest' },
            { state: 'Preis aufsteigend', abbr: 'asc' },
            { state: 'Preis absteigend', abbr: 'desc' },
        ],
    }),
});
